// extracted by mini-css-extract-plugin
export default {"Tag":"CustomTag_Tag__8+oq1","Text":"CustomTag_Text__qwdAP"};